import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Notices } from '../../../../../../../core/entities/notices.model';
import { Texts } from 'src/app/core/entities/texts.model';
import { BOOLEAN_OPTION, DEFAULT_LANG, LS_LANG } from '../../../../../../../core/utils/constants';
import { NoticesService } from 'src/app/core/repositories/notices.service';
import { InternalHomeService } from '../../../../internal-home.service';
import { SelectItem } from 'primeng/api';

@Injectable()
export class EditDialogsNoticesService {

  notice: Notices = new Notices();
  originalNotices: Notices = new Notices();
  NoticesInput: Notices = new Notices();

  allNotices: Notices[] = [];
  changetitulo: boolean = false;

  enable: any[] = BOOLEAN_OPTION;

  texts: Texts[] = new Array<Texts>();

  optionsTitle: SelectItem[] = [];
  optionsDescription: SelectItem[] = [];
  optionstextButton: SelectItem[] = [];

  optionsTitleBase: SelectItem[] = [];
  optionsDescriptionBase: SelectItem[] = [];
  optionstextButtonBase: SelectItem[] = [];

  lang = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
  labelTit: string = "";
  labelDesc: string = "";
  labeltBut: string = "";

  constructor(private noticesService: NoticesService,
              private internalHomeService: InternalHomeService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {

    this.labelTit = "";
    this.labelDesc = "";
    this.labeltBut = "";

    this.notice = data.notice;
    this.changetitulo = data.titulochange;
    this.originalNotices = _.cloneDeep(this.notice);

    return forkJoin({
        valor0: this.internalHomeService.allTexts(),
        valor1: this.noticesService.findAll()
    }).pipe(map(dataGroup => {

      this.texts = _.cloneDeep(dataGroup.valor0);
      this.allNotices = _.cloneDeep(dataGroup.valor1 as Notices[]);

      this.optionsTitleBase.push({value: null, label: ""});
      this.optionsDescriptionBase.push({value: null, label: ""});
      this.optionstextButtonBase.push({value: null, label: ""});

      for(let i = 0; i < this.texts.length; i++){
        this.optionsTitleBase.push({value: this.texts[i].code, label: this.texts[i].code});
        this.optionsDescriptionBase.push({value: this.texts[i].code, label: this.texts[i].code});
        this.optionstextButtonBase.push({value: this.texts[i].code, label: this.texts[i].code});
      }

      this.optionsTitle = this.optionsTitleBase;
      this.optionsDescription = this.optionsDescriptionBase;
      this.optionstextButton = this.optionstextButtonBase;

      if (Utils.noUndfAndNull(data.notice)) {
        this.notice = _.cloneDeep(data.notice);
      }

      if(this.lang == 'ca'){
        this.labelTit = this.notice.title.valuecat;
        this.labelDesc = this.notice.description.valuecat;
        this.labeltBut = this.notice.text_button.valuecat;
      }else{
        this.labelTit = this.notice.title.valueesp;
        this.labelDesc = this.notice.description.valueesp;
        this.labeltBut = this.notice.text_button.valueesp;
      }

      this.optionsTitleBase = [];
      this.optionsDescriptionBase = [];
      this.optionstextButtonBase = [];

      return true;
    }));
  }


  /**
  * @description
  * Guarda el notice
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.notice.code, "")) {

      /*comparamos el ca original con el modificado*/
      let compareNotice = this.compare(this.notice, this.originalNotices);

      if(compareNotice){
        return of(-1);
      }else{
        this.anadirIdObjetosCombo();
        return this.noticesService.postNotice(this.notice);
      }

    }else{
      this.anadirIdObjetosCombo();
      return this.noticesService.postNotice(this.notice);
    }
  }

  /**
  * @description
  * Nos traemos por medio del Code de los combos los Id para así referenciar su objeto correspondiente
  */
  public anadirIdObjetosCombo(){
    for(let i = 0; i < this.texts.length; i++){
      if(this.notice.title.code === this.texts[i].code){
        this.notice.title.id = this.texts[i].id;
      }
      if(this.notice.description.code === this.texts[i].code){
        this.notice.description.id = this.texts[i].id;
      }
      if(this.notice.text_button.code === this.texts[i].code){
        this.notice.text_button.id = this.texts[i].id;
      }
    }
  }

  /**
  * @description
  * Comprueba si dos Notices son iguales.
  * @param datoX Ca 1
  * @param datoY Ca 2
  * @returns True si son iguales
  */
  public compare(itemX:Notices, itemY:Notices):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if (itemX.title.code !== null) {
        let value = itemX.title.code.toString();
        if (value === 'null') {
          itemX.title.code = "";
        }
      }
      if (itemX.description.code !== null) {
        let value = itemX.description.code.toString();
        if (value === 'null') {
          itemX.description.code = "";
        }
      }
      if (itemX.text_button.code !== null) {
        let value = itemX.text_button.code.toString();
        if (value === 'null') {
          itemX.text_button.code = "";
        }
      }

      if (itemX.enable !== null) {
        let value = itemX.enable.toString();
        if (value === 'null') {
          itemX.enable = 0;
        }
      }

      if(itemY.code == null){
        if (itemX.code !== "")
          return false;
      }else{
        if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
        || !Utils.compareTextOrNumber(itemX.title.code, itemY.title.code)
        || !Utils.compareTextOrNumber(itemX.description.code, itemY.description.code)
        || !Utils.compareTextOrNumber(itemX.text_button.code, itemY.text_button.code)
        || !Utils.compareTextOrNumber(itemX.image, itemY.image)
        || !Utils.compareTextOrNumber(itemX.link, itemY.link)
        || !Utils.compareTextOrNumber(itemX.enable, itemY.enable)
        || !Utils.compareTextOrNumber(itemX.order, itemY.order)) 
        && (itemX.code !== "" 
        && Utils.noUndfAndNull(itemX.enable)
        && (Utils.noUndfAndNull(itemX.title.code) && itemX.title.code !== "")
        && (Utils.noUndfAndNull(itemX.description.code) && itemX.description.code !== "")
        && (Utils.noUndfAndNull(itemX.text_button.code) && itemX.text_button.code !== "")))
          return false;
      }
    }
   //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
   else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
     return false;
   }
   return true;
 }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.notice = new Notices();
  }

  valoresTextarea(valor: any, num: number) {
    if(valor == "null" && num == 1){
      this.labelTit = "";
    }
    if(valor == "null" && num == 2){
      this.labelDesc = "";
    }
    if(valor == "null" && num == 3){
      this.labeltBut = "";
    }
    if(this.texts.length > 0){
      for(let i = 0; i < this.texts.length; i++){
        if(valor == this.texts[i].code && num == 1){
          if(this.lang == 'ca'){
            this.labelTit = this.texts[i].valuecat;
          }else{
            this.labelTit = this.texts[i].valueesp;
          }
        }
        if(valor == this.texts[i].code && num == 2){
          if(this.lang == 'ca'){
            this.labelDesc = this.texts[i].valuecat;
          }else{
            this.labelDesc = this.texts[i].valueesp;
          }
        }
        if(valor == this.texts[i].code && num == 3){
          if(this.lang == 'ca'){
            this.labeltBut = this.texts[i].valuecat;
          }else{
            this.labeltBut = this.texts[i].valueesp;
          }
        }
      }
    }
  }

}